import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const dateFormatsK = {
  YYYYMMDD: "date_formats.YYYYMMDD",
  DDMMYYYY: "date_formats.DDMMYYYY",
  MMDDYYYY: "date_formats.MMDDYYYY",
  YYYYDDMM: "date_formats.YYYYDDMM",
};

export const useDateFormatsT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      YYYYMMDD: t(dateFormatsK.YYYYMMDD),
      DDMMYYYY: t(dateFormatsK.DDMMYYYY),
      MMDDYYYY: t(dateFormatsK.MMDDYYYY),
      YYYYDDMM: t(dateFormatsK.YYYYDDMM),
    }),
    [i18n.language]
  );
};